import React from 'react';
import type { GenerateQuoteSectionHeadProps } from './GenerateQuoteSectionHead.types';

/**
 * Full-width header bar: section title (left) and financial totals (right),
 * matching the generate-quote reference layout, themed via GenerateQuoteModal.css.
 */
export const GenerateQuoteSectionHead: React.FC<GenerateQuoteSectionHeadProps> = ({
    title,
    stats,
    ariaLabel,
}) => (
    <header className="obd-gq-section-head" aria-label={ariaLabel}>
        <div className="obd-gq-section-head__title">{title}</div>
        <div className="obd-gq-section-head__stats" role="list">
            {stats.map((s, i) => (
                <div
                    key={`${s.label}-${i}`}
                    className={`obd-gq-section-head__stat${s.emphasize ? ' obd-gq-section-head__stat--emphasis' : ''}`}
                    role="listitem"
                >
                    <span className="obd-gq-section-head__stat-label">{s.label}</span>
                    <span className="obd-gq-section-head__stat-value">{s.value}</span>
                </div>
            ))}
        </div>
    </header>
);

export type { GqSectionStat } from './GenerateQuoteSectionHead.types';
